export default __webpack_public_path__ + "static/IMR_vimeo-b47d71732f9d936d3fa66ef29c54bc7a.mp4";